export default "__VITE_ASSET__17d31253__"